export default "__VITE_ASSET__8c7fa9ae__"